import { ForwardedRef, forwardRef } from 'react';

import { SimpleSearchSelect } from '~src/components/SimpleSearchSelect/SimpleSearchSelect';
import { useLocalizedCountryList } from '~src/i18n/localized-country';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  onChange: (value: string) => void;
  value: string | undefined;
  disabled?: boolean;
  invalid?: boolean;
}

function CountrySelectElement(props: Props, ref: ForwardedRef<HTMLButtonElement>) {
  const { value, invalid, disabled, onChange } = props;

  const countries = useLocalizedCountryList();
  const { t } = useTranslation();

  return (
    <SimpleSearchSelect
      placeholder={t('common.selectCountry')}
      onValueChange={value => onChange(value[0])}
      value={value ? [value] : undefined}
      options={countries}
      disabled={disabled}
      invalid={invalid}
      ref={ref}
    />
  );
}

export const CountrySelect = forwardRef(CountrySelectElement);
